<template>
    <CRow>
        <CCol col=12>
            <CCard>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import store from "@/store";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "GrowthDiseaseImageInput",
  components: {},
};
</script>